export const sessionLogo = (theme) => {
  return {
    display: "flex",
    alignItems: "center",
    width: "360px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  };
};

export const headerLogo = () => {
  return {
    "& img": {
      height: "72px",
    },
  };
};
